import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable, throwError, Subscription } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';

import { queryString, uniqueId, parseDate } from '@teem/helpers/functions';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
declare var $;

@Component({
  selector: 'teemapp-table',
  templateUrl: './teemapp-table.component.html',
  styleUrls: ['./teemapp-table.component.css']
})
export class TeemappTableComponent implements OnInit {
  @Input() tableSchema: any;
  @Input() tableClass: string;
  @Input() divClass: string;  
  @Input() selectable: boolean;
  @Output() onLoad: EventEmitter<any> = new EventEmitter();
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Input() name: string;

  menuItems: Array<object>;
  fromDate: any = null;
  toDate: any = null;
  selectKey: string;
  data: Array<object> = [];
  search = new Subject<string>();
  searchText: string;
  showMenu: boolean = false;
  selected: Array<any> = [];
  selectedRows: Array<any> = [];
  paginator: any = {
		id: 'table-paginator',
		currentPage: 1,
		itemsPerPage: environment.pageSize,
		totalItems: 0
	}
  loading: boolean = false;
  searchSubscription: Subscription;
  filterParams: object = {};
  itemsPerPageOptions = [10, 20, 50, 100];

  @Input('menuItems')
  set setMenuItems(menus: Array<any>) {
    if (menus) {
      menus.forEach(menu => menu.visible = (menu.visible == undefined ? true : menu.visible));
      this.menuItems = menus;
    }
  }

  constructor(private httpClient: HttpClient, private loaderService: LoaderService) { }


  ngOnInit(): void {
    this.selectKey = this.tableSchema.keyColumn;
    console.log('this.selectKey');
    console.log(this.selectKey);
    this.paginator.id = `${this.name}-table-paginator-${uniqueId()}`

    this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(data => {
      if (this.searchText != data) {
        this.searchText = data;

        if (this.searchText.length == 0 || this.searchText.length >= 3) {
          this.getPage(1, false);
        }
      }
    })

    this.getPage(1);
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe()
  }

  resetDateFilters() {
    this.fromDate = null;
    this.toDate = null
    this.filterParams = {};
  }

  reset() {
    this.selected = [];
    this.selectedRows = [];
    this.showMenu = false;
  }

  get totalTableColumns() {
    return ((this.tableSchema.headers.filter((header) => header.hidden != true)).length) + (this.selectable ? 2 : 0);
  }

  onChangeItemsPerPage(event: Event, api: any) {
    const selectElement = event.target as HTMLSelectElement;
    this.paginator.itemsPerPage = +selectElement.value;
    console.log(selectElement.value)
    this.getPage(1);
  }

  public getPage(page: number, loading: boolean = true, additionalParams: any = null) {
    // Unselect selected items
    this.reset();

    if (loading) {
      this.loaderService.startLoading();
      this.loading = true; // to show loading text in table
    }
    console.log(this.paginator)
    let params: any = {
      page: page,
      limit: this.paginator.itemsPerPage
    }

    if (this.searchText && this.searchText.length >= 3) {
      params.q = this.searchText;
    }

    if (additionalParams) {
      Object.assign(this.filterParams, additionalParams);
    }

    Object.assign(params, this.filterParams);

    if (params.from_date) {
      this.fromDate = parseDate(params.from_date);
    }

    if (params.to_date) {
      this.toDate = parseDate(params.to_date);
    }

    if (this.fromDate)
      params.from_date = this.fromDate;

    if (this.toDate)
      params.to_date = this.toDate;

    this.getData(params).subscribe(r => {

      if (r.data)
        this.data = r.data;

      if (r.meta) {
        this.paginator.totalItems = r.meta.total;
        this.paginator.currentPage = r.meta.current_page;
        this.paginator.from = r.meta.from;
        this.paginator.to = r.meta.to;
        // this.paginator.itemsPerPage = r.meta.per_page;
        this.data = r.data;

        this.onLoad.emit({
          totalItems: r.meta.total
        });
      }
      this.loaderService.stopLoading();
      this.loading = false;
      setTimeout(() => {
        $('#tab-links-select[nice-select]').niceSelect('update');
      }, 100);
    }, (err) => {
      this.loading = false;
      this.loaderService.stopLoading()
    })
  }

  getData(params): Observable<any> {
    console.log('get-data:::')
    console.log(params)
    let url = this.tableSchema.serverUrl;
    if (url.indexOf('?') == -1)
      url += ('?' + queryString(params));
    else
      url += ('&' + queryString(params));

    return this.httpClient.get(`${url}`).pipe(
      catchError((err: any) => {
        this.loaderService.stopLoading()
        return throwError(err);
      })
    )
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  toggleSelect(id: any, row: any) {
    let index = this.selected.indexOf(id);
    if (index == -1) {
      this.selected.push(id);

      this.selectedRows[row[this.selectKey]] = row;
      this.onSelect.emit(Object.values(this.selectedRows))
    }
    else {
      this.selected.splice(index, 1);

      delete this.selectedRows[row[this.selectKey]];

      this.onSelect.emit(Object.values(this.selectedRows));

      if (this.selected.length == 0) {
        this.showMenu = false;
      }
    }
  }

  toggleSelectAll() {
    if (this.selected.length < this.data.length) {
      let selected = [];
      for (let item of this.data)
        selected.push(item[this.selectKey])

      this.selected = selected;

      this.selectedRows = this.data;
    } else {
      this.selected = [];
    }
  }

  onMenuClick($event?: any) {
    this.showMenu = false;
    this.selected = [];
  }

  hideMenu($event) {
    this.showMenu = false;
  }

}